import React from 'react';
import classes from './BuildControls.css';
import BuildControl from './BuildControl/BuildControl';

const controls = [
    { label: 'Salad', type: 'salad' },
    { label: 'Bacon', type: 'bacon' },
    { label: 'Cheese', type: 'cheese' },
    { label: 'Meat', type: 'meat' },
]
const buildControls = (props) => (
    <div className={classes.BuildControls}>
        <p className={classes.Total}>Current price: <strong>${props.price.toFixed(2)}</strong></p>
        {controls.map(ctrl =>(
            <BuildControl
            key={ctrl.label}
            label={ctrl.label}
            price={props.ingredientPrices[ctrl.type]}
            count={props.ingredients[ctrl.type]}
            added={()=>props.ingredientAdded(ctrl.type)} 
            removed={()=>props.ingredientRemoved(ctrl.type)}
            disabled={props.disabled[ctrl.type]} />
        ))}
        <button className={classes.OrderButton} disabled={! props.purchasable} onClick={props.ordered}>ORDER NOW</button>
    </div>
);

export default buildControls;


// WEBPACK FOOTER //
// ./src/components/Burger/BuildControls/BuildControls.js